<!--
Author: TangChen
Date: 2018-11-16
Desc: 支持银行阿卡
 -->
<template>
    <div v-if="bankLists.length>0" :class="'bizcomp-support-bank bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="support-bank" :gutter="14">
            <el-col v-for="(bank,index) in bankLists" :key="index" :span="(icon==='up'||index < 36) ? 4 : 0">
                <el-card v-if="icon==='up'||index<36" shadow="hover">
                    <div class="bank-img">
                        <img :src="$util.getImg(bank.bankid)">
                        <span class="k-text-flow" :class="{'fonts':bank.channelname.length>=6}" :title="bank.channelname">{{ bank.channelname.toString().substr(0,6) }}</span>
                    </div>
                    <!--<p class="k-text-flow" :title="bank.bankinfo">{{bank.bankinfo}}</p>-->
                </el-card>
            </el-col>
            <el-col v-if="bankLists.length>36" :span="24" class="more">
                <div v-on:click.prevent="icon=icon==='down'?'up':'down'">
                    <i :class="'fa fa-chevron-'+icon" />{{ icon==='down'?'更多银行':'收起' }}
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "SupportBank",
    mixins: [mixin],
    data () {
        return {
            icon: "down",
            bankLists: []
        };
    },
    created () {
        this.getBankInfo();
    },
    methods: {
        getBankInfo () {
            this.$util.getBankInfo("acct/opentradeacct/banklist",{},res => {
                this.bankLists = res;
            });
        }
    }
};
</script>
<style lang="scss">
  @import '../../assets/css/varibles';
  .bizcomp-support-bank {
    height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
    .support-bank{
      padding: 20px;
      .el-col{margin-bottom: 10px;}
      .el-card__body{padding: 10px;}
      .bank-img{
        height: 30px;
        img{vertical-align: middle;width: 24px;height: 24px;}
        span {
          color: $text-color2;
          font-size: $f18;
          vertical-align: middle;
          line-height: 24px;
          margin-left: 5px;
        }
      }
      p.k-text-flow{color:$text-color3;}
      .more{
        text-align: center;
        color: $color-b;
      }
    }
  }
</style>
